import React from 'react';
import { FiPhoneCall, FiPhoneOff, FiVoicemail } from 'react-icons/fi';

function RingingScreen({ onAccept }) {
  return (
    <div className="screen active">
      <div className="ringing-layout">
        <div className="ring-main" style= {{marginRight: '5px', paddingTop: "20px", paddingBottom: "20px"}}>
          <div className="ring-bg-strip" />
          <div className="ring-wave" />
          <div className="ring-wave" />
          <div className="ring-wave" />
          <div className="ring-avatar">A1</div>
          <div className="ring-name">Agent 1</div>
          <div className="ring-num">+91 XX43</div>
          <div className="ring-label">Incoming Call - Mortgage Refinance Q1</div>
          <div className="ring-actions">
            <div className="ring-action-col">
              <button type="button" className="ring-btn ring-vm"><FiVoicemail /></button>
              <div className="ring-btn-label muted-label">Voicemail</div>
            </div>
            <div className="ring-action-col">
              <button type="button" className="ring-btn ring-accept" onClick={onAccept}><FiPhoneCall /></button>
              <div className="ring-btn-label accept-label">Accept</div>
            </div>
            <div className="ring-action-col">
              <button type="button" className="ring-btn ring-decline"><FiPhoneOff /></button>
              <div className="ring-btn-label decline-label">Decline</div>
            </div>
          </div>
        </div>

        <div className="ring-sidebar">
          <div className="crm-card" style= {{paddingTop: "22px", paddingBottom: "22px"}}>
            <div className="crm-section-title">CRM Profile <span className="crm-badge-source">Salesforce</span></div>
            <div className="crm-profile-head">
              <div className="cti-avatar crm-avatar">A1</div>
              <div><div className="crm-name">Agent 1</div><div className="crm-id">ID: CRM-00412</div></div>
            </div>
            {[
              ['Company', 'TechVenture Pvt Ltd', ''],
              ['City', 'Mumbai, MH', ''],
              ['Loan Amount', 'Rs. 45,00,000', 'blue'],
              ['Credit Score', '782', 'green'],
              ['Last Contact', '3 days ago', ''],
              ['Lead Score', 'HOT - 91/100', 'amber'],
              ['DNC Status', 'CLEAR', 'green'],
              ['Attempts', '4 of 8', ''],
            ].map(([key, value, color]) => (
              <div className="crm-field" key={key}>
                <span className="crm-key">{key}</span>
                <span className={`crm-val ${color}`}>{value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="crm-card">
        <div className="crm-section-title">Campaign Routing</div>
          <div className="campaign-route-card">
            <div className="campaign-route-title">Mortgage Refinance Q1</div>
            <div className="campaign-route-sub">Priority Queue - Predictive Dial - 2nd in queue</div>
          </div>
          <div className="crm-field"><span className="crm-key">DID Number</span><span className="crm-val blue">+91 22 4000 8899</span></div>
          <div className="crm-field"><span className="crm-key">Wait Time</span><span className="crm-val amber">00:38</span></div>
        </div>

      <div className="crm-card">
        <div className="crm-section-title">Previous Outcome</div>
        <div className="announce-card amber-bg no-margin">
          <div className="announce-tag amber-text">Callback Requested</div>
          <div className="announce-copy">"Interested but wanted to review documents. Call back after 3 days."</div>
          <div className="micro-meta">3 days ago - Agent: Nisha P.</div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(RingingScreen);
